import VoidInvoiceModal from './VoidInvoiceModal';

export default VoidInvoiceModal;
